export class DocumentCategoriesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentCategories(params) {
    return this.#http.get('/api/document-categories', { params });
  }

  async createDocumentCategory(body) {
    return this.#http.post('/api/document-categories', body);
  }

  async getDocumentCategoryById({ documentCategoryId, ...params }) {
    return this.#http.get(`/api/document-categories/${documentCategoryId}`, { params });
  }

  async editDocumentCategory(body) {
    return this.#http.put(`/api/document-categories/${body.id}`, body);
  }

  async deleteDocumentCategory({ documentCategoryId, newCategoryId }) {
    const params = newCategoryId ? { newCategoryId } : {};

    return this.#http.delete(`/api/document-categories/${documentCategoryId}`, { params });
  }

  async reorderDocumentCategory(body) {
    return this.#http.put('/api/document-categories/reordering', body);
  }
}
